export const FeatureName = 'comments';
